import { Box, Button, Container, Pagination, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { format } from 'date-fns';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import commaNumber from 'comma-number';
import BookingList from '../LiveDashboard/BookingList';
import FetchLoading from '../../Loading/FetchLoading';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2564b8',
      darker: '#2564b8',
    },
  },
});

const AgentBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [queuesData, setQueuesData] = useState([]);
  const [allQueuesData, setAllQueuesData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const size = 15;

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    fetchQueuesData();
  }, []);

  const fetchQueuesData = () => {
    setIsLoading(true);
    fetch(`https://api-b2b.fasttracktourism.com/agent/booking/${location?.state}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setQueuesData(data);
        setAllQueuesData(data);
      })
      .catch((error) => console.error('Error fetching data:', error))
      .finally(() => setIsLoading(false));
  };

  const handleChangeOption = (e) => {
    const status = e.target.value?.replaceAll(/\s/g, '')?.toLowerCase();
    setStatusFilter(status);
  };

  const handleSearchItems = (e) => {
    const input = e.target.value;
    setSearchInput(input);
  };

  const sendToQueuesDetails = (uid, BookingId, tripType, pnr, gds) => {
    navigate('/dashboard/queuesdetail', {
      state: { uid, BookingId, tripType, pnr, gds, path: 'queues' },
    });
  };

  const filteredQueuesData = queuesData?.filter((item) => {
    const normalizedStatus = item.Status?.replaceAll(/\s/g, '')?.toLowerCase();
    const includesSearchInput = Object.values(item)
      .join('')
      .toLowerCase()
      .includes(searchInput.toLowerCase());

    return (
      (statusFilter === 'all' || normalizedStatus === statusFilter) &&
      includesSearchInput
    );
  });

  return (
    <Box>
      <AdminHeader />

      <Box px={2}>
        <Typography
          sx={{
            color: 'var(--secondary-color)',
            fontSize: '24px',
            fontWeight: '500',
            mb: 1,
          }}
        >
          Queue Management
        </Typography>

        <Box>
          {!isLoading ? (
            <BookingList
              data={queuesData}
              isLoading={isLoading}
              pageSize={15}
            />
          ) : (
            <FetchLoading />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AgentBooking;
